// Core
import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
import { 
	Flex, 
	Button, 
	Box, 
	Image, 
	Grid, 
	Text, 
	Select,
	Spinner, 
	useDisclosure
} from '@chakra-ui/react';
import { Route, Redirect, useRouteMatch, useHistory, useLocation } from 'react-router-dom';
import { FaArrowLeftLong } from 'react-icons/fa6';

// Assets
import { apiService } from 'services/ApiService';
import { textLang } from 'services/Lang';
import logo from 'assets/img/logo.png';
import glow from 'assets/img/1.png';

// Components
import Card from 'components/Card/Card';
import EditField from 'components/Form/EditField';
import EditSelect from 'components/Form/EditSelect';
import ErrorCard from 'components/Form/Errors';
import BirthdayField from 'components/Form/BirthdayField';

const SignUp = () => {
	const currentYear = new Date().getFullYear();

	const [ step, setStep ] = useState(1);
	const [isLoading, setIsLoading] = useState(false);
	const [isError, setIsError] = useState(false);

	const history = useHistory();
	const handleLogin = async () => {
		setIsLoading(true);
		setIsError();

		const webApp = window.Telegram.WebApp;
	    webApp.ready();

	    const initData = webApp.initData;
		console.log('initData:', initData); // Логируем initData

		if (!initData) {
		    setIsError('Telegram initData is missing');
		    setIsLoading(false);

		    setStep(2); 
			setIsLoading(false);
		    return;
		}

		try {
			const response = await apiService.checklogin({initData});
			if(response.statusCode === 200){
				if(response?.data?.accessToken){
		          localStorage.setItem('auth', JSON.stringify(response.data));
		        }
		        history.push('/profile'); 
		        setIsLoading(false);
		        return;
			}
		} catch(e) {
			setStep(2); 
			setIsLoading(false);	
		}

		setStep(2); 
		setIsLoading(false);
	};

	const handleSignUp = async () => {
		setIsLoading(true);
		setIsError();

		const webApp = window.Telegram.WebApp;
	    webApp.ready();

	    const initData = webApp.initData;
		console.log('initData:', initData); // Логируем initData

		console.log(object);

		if (!initData) {
		    setIsError(textLang('initData'));
		    setIsLoading(false);
		    return;
		}

		try {
			const response = await apiService.login({...object, initData});
			if(response.statusCode === 200 || response.statusCode === 201){
				if(response?.data?.accessToken){
		          localStorage.setItem('auth', JSON.stringify(response.data));
		        }

		        history.push('/profile'); 

		        setIsLoading(false);
			} else if (response.statusCode === 401 || response.statusCode === 400){
				setIsLoading(false);
				setIsError(response.message);
			}

			setIsLoading(false);
			setIsError(response.statusCode);
		} catch(e) {
			setIsLoading(false);
			setIsError(e);
		}

		//console.log(object);
		//localStorage.setItem('auth', JSON.stringify(object)); 
	    //history.push('/profile'); 
	};

	const interestsOptions = [
	  'Music', 'Sports', 'Travel', 'Movies', 'Gaming', 'Reading',
	  'Cooking', 'Dancing', 'Art', 'Technology', 'Fitness', 'Photography',
	  'Nature', 'Fashion', 'Anime',
	  'Hiking', 'Camping', 'Running', 'Swimming', 'Yoga', 'Meditation',
	  'Astronomy', 'Science', 'Psychology', 'Philosophy', 'History', 'Politics',
	  'Languages', 'Writing', 'Poetry', 'Painting', 'Drawing', 'DIY',
	  'Gardening', 'Cars', 'Motorcycles', 'Aviation', 'Space', 'Coding',
	  'Startups', 'Crypto', 'AI', 'Esports', 'Board Games', 'Chess',
	  'Volunteering', 'Animals', 'Dogs', 'Cats', 'Coffee', 'Tea',
	  'Food', 'Baking', 'Wine', 'Traveling', 'Beaches', 'Mountains',
	  'Urban Exploring', 'Minimalism', 'Sustainability', 'Interior Design', 'Makeup', 'Skincare',
	  'Tattoos', 'Piercing', 'Festivals', 'Photography Film', 'Vintage', 'Comics',
	  'Manga', 'KPop', 'Movies Classic', 'Standup', 'Podcasts', 'Collecting',
	  'Traveling Solo', 'Surfing', 'Snowboarding', 'Hiking Trails'
	];

	const [object, setObject] = useState({
		gender: null,
		birthday: null,
		description: null,
		country: null,
		city: null,
		interests: [],
		relationship: null,
		findGender: null,
		findFor: null,
		lat: 0,
		long: 0,
		findAge: [18,60]
	});

	const [startButton, setStartButton] = useState(false);
	const [geoDenied, setGeoDenied] = useState(false);
	const getCityCountry = async (lat, lon) => {
	  const res = await fetch(
	    `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}&zoom=10&addressdetails=1&accept-language=en`
	  );
	  const data = await res.json();
	  const city = data.address.state || data.address.city || data.address.town || data.address.village;
	  const country = data.address.country;
	  return { city, country };
	};

 const requestLocation = async () => {
    if (!navigator.geolocation) {
      setGeoDenied(true);
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async (pos) => {
        const { latitude, longitude } = pos.coords;
        const result = await getCityCountry(latitude, longitude);

        setObject((prev) => ({
          ...prev,
          ...result,
          lat: latitude,
          long: longitude,
        }));
        setStartButton(true);
        setGeoDenied(false);
      },
      (err) => {
        console.warn('Geo error:', err);
        setGeoDenied(true);
      }
    );
  };

  // Проверка прав при монтировании
  useEffect(() => {
    if (navigator.permissions) {
      navigator.permissions
        .query({ name: 'geolocation' })
        .then((result) => {
          if (result.state === 'granted') {
            requestLocation();
          } else if (result.state === 'prompt') {
            // ещё не спрашивали — пробуем
            requestLocation();
          } else if (result.state === 'denied') {
            setGeoDenied(true);
          }
        });
    } else {
      // если Permissions API нет, просто пробуем
      requestLocation();
    }
  }, []);

	const toggleInterest = (interest) => {
	  setObject((prev) => {
	    const updatedInterests = prev.interests.includes(interest)
	      ? prev.interests.filter((i) => i !== interest)
	      : [...prev.interests, interest];

	    return { ...prev, interests: updatedInterests };
	  });
	};

	const [objectErrors, setObjectErrors] = useState([]);
	const [errorCard, setErrorCard] = useState();

	const setData = useCallback((maxValue, target, key) => {
		if (target.length < maxValue) {
		  setObjectErrors([...objectErrors, key]);
		} else {
		  setObjectErrors(objectErrors.filter(error => error !== key));
		}
		setObject({...object, [key]: target}); 
	}, [object, objectErrors, setObject, setObjectErrors]);

	const handleField = useMemo(() => {
		const fieldConfigs = [
		  { field: 'gender', maxValue: 1 },
		  { field: 'birthday', maxValue: 0 },
		  { field: 'description', maxValue: 0 },
		  { field: 'lat', maxValue: 0 },
		  { field: 'long', maxValue: 0 },
		  { field: 'country', maxValue: 0 },
		  { field: 'city', maxValue: 0 },
		  { field: 'relationship', maxValue: 0 },
		  { field: 'findGender', maxValue: 0 },
		  { field: 'findFor', maxValue: 0 },
		];

		setErrorCard();

		return fieldConfigs.reduce((acc, { field, maxValue }) => {
		  acc[field] = (e) => setData(maxValue, e.target.value, field);
		  return acc;
		}, {});
	}, [setData]);

	const [editMode, setEditMode] = useState(true);

	const currentLang = localStorage.getItem('lang') || 'en';

	const handleChange = (e) => {
    const lang = e.target.value;
    localStorage.setItem('lang', lang);
    window.location.href = '/';
  };

	return (
		<Box w="100%" position="relative" textAlign="center">
			{ step === 1 && (
				<>
					<Select
						w="200px"
						className="change-lang"
						m="0 auto 12px auto"
			      defaultValue={currentLang}
			      onChange={handleChange}
			    >
			      <option value="en">English 🇬🇧</option>
			      <option value="ru">Русский 🇷🇺</option>
					</Select>

					<Image src={logo} maxW="380px" m="0 auto" w="100%" />

					<Text m="-24px auto 0 auto" maxW="80%" variant="title-lg">
						{textLang('auth_hello_header')}
					</Text>

					<Text m="8px auto 24px auto" maxW="90%" variant="text-sm">
						{textLang('auth_hello_sub')}
					</Text>

					<Image src={glow} m="0 auto" />

					<Box px="10%">
						{geoDenied ? (
						  <ErrorCard error={textLang('auth_hello_error_location')} mt="0px" />
					    ) : (
					      <Button
					        variant="button-lg"
					        isLoading={isLoading}
					        disabled={!startButton}
					        onClick={handleLogin}
					      >
					        {textLang('auth_hello_next_button')}
					      </Button>
					    )}
					</Box>

					<Box maxW="90%" m="32px auto 0 auto">
						<Text variant="text-xs">🚀 {currentYear} Mega Meet KLKILabs – Making Connections That Matter.</Text>
						<Text variant="text-xs">Powered by KLKILabs.org</Text>
						<Text variant="text-xs">All rights reserved.</Text>
					</Box>
				</>
			)}

			{ step === 2 && (
				<Box px="10%">
					<Text variant="title-lg" py="8px">{textLang('auth_hello_step2_header')}</Text>
					<Text variant="text-md" mb="44px">{textLang('auth_hello_step2_sub')}</Text>

					<Box>
				        <EditSelect 
				        	editMode={editMode}
				        	options={[
				        		{ value: 'Male', title: textLang('gender_male') },
				        		{ value: 'Female', title: textLang('gender_female') },
				        		{ value: 'Transgender', title: textLang('gender_transgender') },
				        		{ value: 'Unknown', title: textLang('gender_other') },
				        	]}
				        	id="gender" placeholder={textLang('placeholder_gender')} value={object.gender} onChange={handleField.gender} isValid={true}  />
						
				        <EditSelect 
				        	editMode={editMode}
				        	options={[
				        		{ value: 'Male', title: textLang('gender_male') },
				        		{ value: 'Female', title: textLang('gender_female') },
				        		{ value: 'Transgender', title: textLang('gender_transgender') },
				        		{ value: 'Unknown', title: textLang('gender_other') },
				        	]}
				        	id="findGender" placeholder={textLang('placeholder_gender_interest')}  value={object.findGender} onChange={handleField.findGender} isValid={true}  />

			        </Box>

			        <Flex mt="32px" gap="8px" justifyContent="center">
			        	<Box w="20px" h="3px" bg="#0D234D" borderRadius="full" />
			        	<Box w="20px" h="3px" bg="#b5b5b5" borderRadius="full" />
			        	<Box w="20px" h="3px" bg="#b5b5b5" borderRadius="full" />
			        	<Box w="20px" h="3px" bg="#b5b5b5" borderRadius="full" />
			        	<Box w="20px" h="3px" bg="#b5b5b5" borderRadius="full" />
			        	<Box w="20px" h="3px" bg="#b5b5b5" borderRadius="full" />
			        	<Box w="20px" h="3px" bg="#b5b5b5" borderRadius="full" />
			        </Flex>

			        <Flex mt="16px" gap="16px" alignItems="center">
			        	<Button w="88px" variant="solid-lg" onClick={() => setStep(1)}><FaArrowLeftLong fontSize="16px" /></Button>
						<Button 
							disabled={ object?.gender?.length > 0 && object?.findGender?.length > 0 ? false : true } 
							variant="button-lg" onClick={() => setStep(3)}>{textLang('next')}</Button>
					</Flex>
				</Box>
			)}

			{ step === 3 && (
				<Box px="10%">
					<Text variant="title-lg" py="8px">{textLang('auth_hello_step3_header')}</Text>
					<Text variant="text-md" mb="24px">{textLang('auth_hello_step3_sub')}</Text>

					<Box position="relative">
						<Box
							pointerEvents="none"
							w="100%" h="30px" position="absolute" top="0" left="0" bg="linear-gradient(180deg, #f1f1f1, transparent)" zIndex="9" />
						<Box overflow="scroll" pb="30px" height="38vh" border="1px solid #f1f1f1">
							<Flex flexWrap="wrap" gap="8px" mt="12px">
							  {interestsOptions.map((interest) => (
							    <Box
							      key={interest}
							      cursor="pointer"
							      px="12px"
							      py="6px"
							      borderRadius="16px"
							      border="1px solid"
							      bg={object.interests.includes(interest) ? '#ff4133' : 'transparent'}
							      color={object.interests.includes(interest) ? 'white' : 'black'}
							      fontWeight="500"
							      onClick={() => toggleInterest(interest)}
							      transition="0.2s ease-in-out"
							    >
							      {textLang(interest)}
							    </Box>
							  ))}
							</Flex>
						</Box>
						<Box
							pointerEvents="none" 
							w="100%" h="30px" position="absolute" bottom="0" left="0" bg="linear-gradient(0deg, #f1f1f1, transparent)" zIndex="9" />
					</Box>

	        <Flex mt="64px" gap="8px" justifyContent="center">
	        	<Box w="20px" h="3px" bg="#0D234D" borderRadius="full" />
	        	<Box w="20px" h="3px" bg="#0D234D" borderRadius="full" />
	        	<Box w="20px" h="3px" bg="#b5b5b5" borderRadius="full" />
	        	<Box w="20px" h="3px" bg="#b5b5b5" borderRadius="full" />
	        	<Box w="20px" h="3px" bg="#b5b5b5" borderRadius="full" />
	        	<Box w="20px" h="3px" bg="#b5b5b5" borderRadius="full" />
	        	<Box w="20px" h="3px" bg="#b5b5b5" borderRadius="full" />
	        </Flex>

			    <Flex mt="16px" gap="16px" alignItems="center">
			      <Button w="88px" variant="solid-lg" onClick={() => setStep(2)}><FaArrowLeftLong fontSize="16px" /></Button>
						<Button
							disabled={ object.interests.length >= 3 ? false : true } 
							variant="button-lg" onClick={() => setStep(4)}>{object.interests.length}/3 {textLang('next')}</Button>
					</Flex>
				</Box>
			)}

			{ step === 4 && (
				<Box px="10%">
					<Text variant="title-lg" py="8px">{textLang('auth_hello_step4_header')}</Text>
					<Text variant="text-md" mb="44px">{textLang('auth_hello_step4_sub')}</Text>

					<Box>
				        <EditSelect 
				        	editMode={editMode}
				        	options={[
				        		{ value: 'Single', title: textLang('Single') },
				        		{ value: 'In a relationship', title: textLang('In a relationship') },
				        		{ value: 'Married', title: textLang('Married') },
				        		{ value: 'It’s complicated', title: textLang('It’s complicated') },
				        		{ value: 'Open Relationship', title: textLang('Open Relationship') },
				        		{ value: 'Divorced', title: textLang('Divorced') },
				        		{ value: 'Widowed', title: textLang('Widowed') },
				        	]}
				        	id="relationship" value={object.relationship} onChange={handleField.relationship} placeholder={textLang('placeholder_relationship')} isValid={true}  />

				        <EditSelect 
				        	editMode={editMode}
				        	options={[
				        		{ value: 'Serious relationship', title: textLang('Serious relationship') },
				        		{ value: 'Casual dating', title: textLang('Casual dating') },
				        		{ value: 'Friendship', title: textLang('Friendship') },
				        		{ value: 'Hangouts', title: textLang('Hangouts') },
				        		{ value: 'Networking', title: textLang('Networking') },
				        		{ value: 'Fun & No commitments', title: textLang('Fun & No commitments') }
				        	]}
				        	id="findFor" value={object.findFor} onChange={handleField.findFor} placeholder={textLang('placeholder_looking_for')} isValid={true}  />

			        </Box>

			        <Flex mt="32px" gap="8px" justifyContent="center">
			        	<Box w="20px" h="3px" bg="#0D234D" borderRadius="full" />
			        	<Box w="20px" h="3px" bg="#0D234D" borderRadius="full" />
			        	<Box w="20px" h="3px" bg="#0D234D" borderRadius="full" />
			        	<Box w="20px" h="3px" bg="#b5b5b5" borderRadius="full" />
			        	<Box w="20px" h="3px" bg="#b5b5b5" borderRadius="full" />
			        	<Box w="20px" h="3px" bg="#b5b5b5" borderRadius="full" />
			        	<Box w="20px" h="3px" bg="#b5b5b5" borderRadius="full" />
			        </Flex>

			        <Flex mt="16px" gap="16px" alignItems="center">
			        	<Button w="88px" variant="solid-lg" onClick={() => setStep(3)}><FaArrowLeftLong fontSize="16px" /></Button>
						<Button 
							disabled={ object.findFor?.length > 0 && object.relationship?.length > 0 ? false : true } 
							variant="button-lg" onClick={() => setStep(5)}>{textLang('next')}</Button>
					</Flex>
				</Box>
			)}

			{ step === 5 && (
				<Box px="10%">
					<Text variant="title-lg" py="8px">{textLang('auth_hello_step5_header')}</Text>
					<Text variant="text-md" mb="44px">{textLang('auth_hello_step5_sub')}</Text>

					<Box>
				      <EditField editMode={editMode} id="description" placeholder={textLang('bio')} type="textarea" value={object.description
				        } isValid={true} onChange={handleField.description} />
			        </Box>

			        <Flex mt="32px" gap="8px" justifyContent="center">
			        	<Box w="20px" h="3px" bg="#0D234D" borderRadius="full" />
			        	<Box w="20px" h="3px" bg="#0D234D" borderRadius="full" />
			        	<Box w="20px" h="3px" bg="#0D234D" borderRadius="full" />
			        	<Box w="20px" h="3px" bg="#0D234D" borderRadius="full" />
			        	<Box w="20px" h="3px" bg="#b5b5b5" borderRadius="full" />
			        	<Box w="20px" h="3px" bg="#b5b5b5" borderRadius="full" />
			        	<Box w="20px" h="3px" bg="#b5b5b5" borderRadius="full" />
			        </Flex>

			        <Flex mt="16px" gap="16px" alignItems="center">
			        	<Button w="88px" variant="solid-lg" onClick={() => setStep(4)}><FaArrowLeftLong fontSize="16px" /></Button>
						<Button
							disabled={ object?.description?.length >= 3 ? false : true }  
							variant="button-lg" onClick={() => setStep(6)}>{textLang('next')}</Button>
					</Flex>
				</Box>
			)}

			{ step === 6 && (
				<Box px="10%">
					<Text variant="title-lg" py="8px">{textLang('auth_hello_step6_header')}</Text>
					<Text variant="text-md" mb="44px">{textLang('auth_hello_step6_sub')}</Text>

					<Box>  
		        <Text variant="title-md" pb="12px">{textLang('auth_hello_step6_sub_sub')}</Text>
		        
		        <BirthdayField
						  editMode={true}
						  id="birthday"
						  type="custom"
						  value={object.birthday}
						  isValid={true}
						  onChange={handleField.birthday}
						/>
	        </Box>

	        <Flex mt="32px" gap="8px" justifyContent="center">
	        	<Box w="20px" h="3px" bg="#0D234D" borderRadius="full" />
	        	<Box w="20px" h="3px" bg="#0D234D" borderRadius="full" />
	        	<Box w="20px" h="3px" bg="#0D234D" borderRadius="full" />
	        	<Box w="20px" h="3px" bg="#0D234D" borderRadius="full" />
	        	<Box w="20px" h="3px" bg="#0D234D" borderRadius="full" />
	        	<Box w="20px" h="3px" bg="#b5b5b5" borderRadius="full" />
	        	<Box w="20px" h="3px" bg="#b5b5b5" borderRadius="full" />
	        </Flex>

	        <Flex mt="16px" gap="16px" alignItems="center">
	        	<Button w="88px" variant="solid-lg" onClick={() => setStep(5)}><FaArrowLeftLong fontSize="16px" /></Button>
						<Button 
							disabled={ (object?.birthday === null || object?.birthday === 0 || object?.birthday?.length === 0) ? true : false }  
							variant="button-lg" onClick={() => setStep(7)}>{textLang('next')}</Button>
					</Flex>
				</Box>
			)}

			{ step === 7 && (
				<Box px="10%">
					<Text variant="title-lg" py="8px">{textLang('auth_hello_step7_header')}</Text>

	        <Flex mt="16px" gap="16px" alignItems="center">
	        	<Button w="88px" variant="solid-lg" onClick={() => setStep(6)}><FaArrowLeftLong fontSize="16px" /></Button>
						<Button variant="button-lg" onClick={handleSignUp} isLoading={isLoading}>{textLang('auth_hello_step7_btn')}</Button>
					</Flex>

					{ isError && <ErrorCard error={isError} mt="24px" /> }
				</Box>
			)}
			
		</Box>
	);
};

export default SignUp;